import { create } from 'apisauce'

const api = create({
  /* baseURL: process.env.REACT_APP_END_POINTS_1_URL || 'https://oikoslab.ecoss.is/oikos/end_points_1.php', */
  baseURL: process.env.REACT_APP_END_POINTS_1_URL || 'https://oikos.ecoss.is/oikos/end_points_1.php',
})

api.addResponseTransform(response => {
  if (!response.ok) throw response
})

export default api
